import { Role, User } from '../entity/user';
import { UserType } from '../state/types';

export const isAdmin = (user: User | UserType): boolean =>
  user?.role === Role.BL_ADMIN || user?.role === Role.FIRM_ADMIN;
